import type { ContainerProps } from 'react-bootstrap/Container';
import Container from 'react-bootstrap/Container';
import type { RowProps } from 'react-bootstrap/Row';
import Row from 'react-bootstrap/Row';
import type { ColProps } from 'react-bootstrap/Col';
import Col from 'react-bootstrap/Col';

export type { ContainerProps, ColProps, RowProps };
export { Container, Row, Col };
